import styled, { css } from 'styled-components';
import { cond, equals, allPass } from 'ramda';

import { themeColor, themeZIndex } from '../../../theme/getters';
import { Icon } from '../icon';

export const Container = styled.div``;

export const TRANSITION_DURATION = 500;

const hidden = () => css`
  transform: translateY(-100%);
  opacity: 0;
`;

const shown = () => css`
  transform: translateY(0);
  opacity: 1;
`;

export const SnackbarContainer = styled.div`
  position: fixed;
  width: 100vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  top: 0;
  z-index: ${themeZIndex('snackbar')};
  min-height: 80px;
  background-color: ${themeColor('primary')};
  transition: all ${TRANSITION_DURATION}ms;
  transform: translateY(100%);
  opacity: 0;

  ${({ state }) => cond([[equals('entered'), shown], [allPass(['entering', 'exiting', 'exited']), hidden]])(state)}
`;

export const WhiteIcon = styled(Icon)`
  color: white;
`;
